import {
    CHANGE_FILTERS
} from "Stores/actionTypes";
import {updateObject} from "./utility";

const initialState = {
    filters: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_FILTERS:
            return updateObject(state, {
                filters: action.filters,
            });
        default:
            return state;
    }
};

export default reducer;
